import { HttpInterceptorFn } from '@angular/common/http';
import { TOAST_LOADING } from './peticion-api.interceptor';
import { inject } from '@angular/core';
import { ToastService } from 'ng-components-tsi';
import { finalize } from 'rxjs';
import { API_DESC } from './peticion-history.interceptor';

export const peticionApiReportsInterceptor: HttpInterceptorFn = (req, next) => {

  const useToast = req.context.get(TOAST_LOADING);
  const descri = req.context.get(API_DESC);

  if (!useToast) {
    return next(req)
  }

  const toast = inject(ToastService)
  let toastId: number | null = null;
  // const nameFile = extractFileNameFromUrl(req.url)
  if (useToast) {
    toastId = toast.showLoading(`Cargando ${descri || 'download_file' }`)
  }

  return next(req).pipe(finalize(() => {
    if (useToast && toastId != null) {
      toast.updateProgress(toastId, 100)
      toast.remove(toastId)
    }
  }))
}